export enum UserMenuOptionName {
  ViewProfile = "viewProfile",
  ChangePassword = "changePassword",
  CheckSession = "checkSession",
  ManageSubscription = "manageSubscription",
  EmailMobileLinkToMyPhone = "emailMobileLinkToMyPhone",
  OpenPersonalAccessToken = "openPersonalAccessToken",
  Logout = "logout",
}
